import { AnimatedHeading } from '@/components/astro/new-design/animated-heading';
import * as m from '@/paraglide/messages';
import { usePostPurchaseStep } from './post-purchase.store';
import { postPurchasePages } from './post-purchase-pages';

export function PostPurchaseNavHeader() {
  const currentStep = usePostPurchaseStep();

  const labelMap: Record<
    (typeof postPurchasePages)[number]['pageName'],
    string
  > = {
    feedback: m.post_purchase_feedback_heading(),
    welcome: m.post_purchase_welcome_heading(),
  };

  return (
    <AnimatedHeading
      currentStep={currentStep}
      pages={postPurchasePages.map((p) => ({
        label: labelMap[p.pageName],
      }))}
    />
  );
}
